import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-anti-ragging-committee',
  templateUrl: './anti-ragging-committee.component.html',
  styleUrls: ['./anti-ragging-committee.component.scss']
})
export class AntiRaggingCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
